<template>
  <div class="container">
    <div class="main-title header">
      <h4>回测数据归属: {{ taskInfo.canteen_name }} {{ tsToDate }}<span>;&nbsp;&nbsp;&nbsp;&nbsp;  操作人: <el-tag type="success">{{taskInfo
        .username}}</el-tag></span></h4>
    </div>
    <el-row :gutter="10" v-if="currentDishModel">
      <el-row :gutter="5" class="class-dish">
        <el-col :span="12">
          <el-card v-if="currentDishModel" class="box-card">
            <div slot="header" class="clearfix">
              <h3 class="header-title">
                第
                <span class="danger-text">{{ currentIndex + 1 }}</span>
                <span>/{{ `${dishModelCount}` }}个碗</span>
                名称:
                {{
                  currentDishModel && currentDishModel.dish_name
                    ? currentDishModel.dish_name
                    : '暂无名称'
                }}
              </h3>
	            <!--<span class="tag-wrapper" v-if="currentClassImages.length > 0"></span>-->
	            <!--<el-tag v-else type="danger">无碗碟</el-tag>-->
              <div class="btn-wrapper-1">
                <span>
                  <el-button
	                  type="primary"
                    size="mini"
	                  :disabled="currentIndex < 1"
	                  @click="preDishModel"
                  >上一个</el-button
                  >
                  <el-button
                    size="mini"
	                  type="primary"
	                  :disabled="currentIndex === dishModelCount - 1"
	                  @click="nextDishModel"
                  >下一个</el-button
                  >
                  <el-button
                    size="mini"
	                  type="success"
	                  class="btn-alone"
	                  @click="checkFinished"
	                  v-if="checkMode"
                  >纠错结束</el-button
                  >
                  <el-button
	                  type="success"
	                  class="btn-alone"
	                  @click="backToAcc"
	                  v-if="backToAccBtnShow"
                  >返回准确率
                  </el-button>
                </span>
              </div>
            </div>
            <classDishWrapper
	            class="class-dish-wrapper"
	            :image="currentDishModel"
            ></classDishWrapper>
            <h3
	            class="tip"
	            :class="
                currentDishModel.dish_type === '1'
                  ? 'primary-text'
                  : 'danger-text'
              "
            >
              此碗是
              <span
	              v-if="currentDishModel.dish_type === '1'"
	              class="danger-text"
              >碗碟识别模式</span
              >
              <span v-else class="primary-text">内容识别模式</span>, 请重点检查
              <span
	              v-if="currentDishModel.dish_type === '1'"
	              class="danger-text"
              >碗碟</span
              >
              <span v-else class="primary-text">内容</span
              >,和实例中的是否相符!!!
              <br/>
              <span v-if="label_task_uuid_list.length > 1">
                <el-button
	                type="primary"
	                :disabled="labelTaskIndex < 1"
	                @click="preTask"
                >上一批</el-button
                >
                <el-button
	                type="primary"
	                :disabled="
                    labelTaskIndex === this.taskInfo.label_task_uuid.length - 1
                  "
	                @click="nextTask"
                >下一批</el-button
                >
              </span>
            </h3>
          </el-card>
          <span v-else>暂无例图!</span>
        </el-col>
        <el-col :span="6">
          <el-card
	          class="delete-card"
	          :body-style="{ height: '150px', 'overflow-y': 'scroll' }"
          >
            <div slot="header" class="clearfix">
              <h3 class="header-title danger-text">被删除图片</h3>
            </div>
            <div class="image-wrapper image-wrapper-deleted">
              <div
	              class="image-item-wrapper"
	              v-for="dish in deletedImageList"
	              :key="dish.dish_img_uuid"
              >
                <el-popover
	                popper-class="big-img"
	                ref="popover2"
	                placement="top-start"
	                trigger="click"
                >
                  <div class="big-img-wrapper">
                    <img :src="dish.dish_img_url" width="150px" alt/>
                  </div>
                  <img :src="dish.dish_img_url" slot="reference" width="50px" alt/>
                </el-popover>
              </div>
            </div>

            <div class="image-wrapper">
              <div
	              class="image-item-wrapper"
	              v-for="dish in currentClassDeleted"
	              :key="dish.img_uuid"
              >
                <el-popover
	                popper-class="big-img"
	                ref="popover2"
	                placement="top-start"
	                trigger="click"
                >
                  <img
	                  :src="dish.img_url"
	                  class="image-item"
	                  slot="reference"
	                  alt
                  />
                  <div class="big-img-wrapper">
                    <!--<el-button-->
	                  <!--type="primary"-->
	                  <!--class="btn"-->
	                  <!--style="position: absolute"-->
	                  <!--@click="unDelete(dish);">撤回</el-button>-->
                    <img :src="dish.img_url" width="150px" alt/>
                  </div>
                </el-popover>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6">
          <el-card
	          class="delete-card"
	          :body-style="{ height: '150px', 'overflow-y': 'scroll' }"
          >
            <div slot="header" class="clearfix">
              <h3 class="header-title danger-text">被重新标注图片</h3>
            </div>
            <div class="image-wrapper">
              <div
	              class="image-item-wrapper"
	              v-for="dish in currentClassRemark"
	              :key="dish.dish_img_uuid"
              >
                <el-popover
	                popper-class="big-img"
	                ref="popover2"
	                placement="top-start"
	                trigger="click"
                >
                  <img
	                  :src="dish.img_url"
	                  class="image-item"
	                  slot="reference"
	                  alt
	                  width="50px"
	                  height="50px"
                  />
                  <div class="big-img-wrapper">
                    <div class="image-wrapper">
                      <img
	                      :src="dish.img_url"
	                      width="100px"
	                      class="image-item"
	                      alt
                      />
                    </div>
                    移动到:
                    <classDishWrapper
	                    :image="{
                        class_id: dish.class_id,
                        dish_url: dish.dish_url
                      }"
	                    class="class-dish-wrapper"
                    ></classDishWrapper>
                  </div>
                </el-popover>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <h2 class="process-title">
        <!-- // 自查 -->
        <el-badge class="mark" :value="currentClassImagesLeft.length || 0">
          <span>本次审查中确认正确的图片</span>
        </el-badge>
	      <!-- 审查 -->
      </h2>
      <imageMarkWrapperforDeceted
	      v-if="currentClassImagesLeft.length > 0"
	      :images="currentClassImagesLeft"
	      :current_class_id="currentDishModel.class_id"
	      :selfCheck="selfCheck"
	      @pageChange="pageChange"
	      :checkMode="checkMode"
	      @delete="handleDelete"
      ></imageMarkWrapperforDeceted>
      <h3 class="tip-wrapper" v-else>
        当前例图暂无图片
        <el-button
	        type="primary"
	        :disabled="currentIndex < 1"
	        @click="preDishModel"
        >上一个</el-button
        >
        <el-button
	        type="primary"
	        :disabled="currentIndex === dishModelCount - 1"
	        @click="nextDishModel"
        >下一个</el-button
        >
      </h3>
    </el-row>
    <el-row :gutter="10" v-else>
      <span>暂无标准例图</span>
    </el-row>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import {
  apiGetCheckedImgByTaskId,
  apiGetClassDishByClassId,
  apiGetImgByUuidList,
  apiHistoryTaskRemark,
  apiQueryCanteenClassList
} from '@/api';
import imageMarkWrapperforDeceted from '_c/imageMarkWrapperforDeceted';
import classDishWrapper from '_c/classDishWrapper';

import moment from 'moment';

export default {
  name: 'taskHistoryRecheck',
  components: {
    imageMarkWrapperforDeceted,
    classDishWrapper
  },
  data () {
    const validatePass = (rule, value, callback) => {
      console.log(`ssssssssssssssss`, value);
      if (value === '') {
        callback(new Error('请输出审查意见'));
      } else {
        callback();
      }
    };
    return {
      currentClassDeleted: [],
      currentClassRemark: [],
      preRouter: '',
      backToAccBtnShow: false,
      labelTaskIndex: 0,
      deletedImageList: [],
      checkedHistory: {},
      classDishList: [],
      modelList2: [],
      currentIndex: 0,
      checkFailReasonShow: false,
      checkFailReason: '',
      detectedData: {},
      isLastPage: false,
      deletedImages: []
    };
  },
  mounted () {
    this.setSubTitle('历史回溯');
    this.getModelList();
    // this.getBackImages();
    this.getTaskInfo();
  },
  beforeRouteEnter (to, from, next) {
    console.log(from.name);
    next(vm => {
      if (
        from.name === 'backDataAccByCanteen' ||
        from.name === 'backDataAccSummary'
      ) {
        vm.backToAccBtnShow = true;
        vm.preRouter = from.name;
        vm.reset();
      }
    });
  },
  methods: {
    ...mapMutations([
      'emitLoading',
      'removeLoading',
      'setSubTitle',
      'unMark',
      'setAllImageList'
    ]),
    backToAcc () {
      if (this.preRouter === 'backDataSummary') {
        this.$router.push({
          name: 'backDataSummary'
        });
      } else {
        this.$router.push({
          name: this.preRouter,
          params: {
            canteen: this.canteen,
            dateRange: this.dateRange
          }
        });
      }
    },
    nextTask () {
      if (this.labelTaskIndex < this.modelList.length) {
        this.labelTaskIndex++;
      }
    },
    preTask () {
      if (this.labelTaskIndex > 0) {
        this.labelTaskIndex--;
      }
    },
    async checkFinished () {
      if (this.currentIndex !== this.modelList.length - 1) {
        return this.$message.error('只能在最后一个碗碟才能纠错结束');
      }
      try {
        // 保存;
        if (this.deletedImageList.length > 0) {
          this.$router.push({
            name: 'backDataMultiDragBeforeNewTask',
            params: {
              imageList: this.deletedImageList,
              modelList: this.modelList2,
              canteen: this.canteen,
              dateRange: this.dateRange,
              label_task_uuid: this.currentTask
            }
          });
        } else {
          // 就错, 重新标注结束
          try {
            await apiHistoryTaskRemark({
              label_info_list: [],
              label_task_uuid: this.currentTask,
              train_check_state: '1',
              username: this.username
            });
            this.$eventHub.$emit('taskReviewed', this.currentTask);
            this.$router.back();
          } catch (e) {
            this.$message.error('失败');
            console.log(e);
          }
        }
        this.removeLoading(500);
      } catch (e) {
        console.log(e);
      }

      // this.$router.push({
      //   name: 'backDataImageMark',
      //   params: {
      //
      //   }
      // });
    },
    handleDelete (e) {
      let list = this.currentClassImages.marked_img_info;
      console.log(list);
      let res = this.$_.find(list, a => {
        return a.dish_img_uuid === e;
      });
      if (res) {
        this.$set(res, 'class_id', '-1');
      }
      this.deletedImageList.push(res);
    },
    async getTaskInfo () {
      try {
        this.emitLoading();
        let res = await apiGetCheckedImgByTaskId(this.currentTask);
        let modelList = await apiGetClassDishByClassId(Object.keys(res));
        this.classDishList = this.$_.uniqBy(modelList.class_admin_list, 'class_id');
        this.checkedHistory = res;
        this.currentIndex = this.choose_class_idx || 0;
        if (this.$_.isEmpty(this.checkedHistory)) {
          this.$message.error('此条任务为空');
        } else {
          let deletedList = this.currentClassImages.delete_img_list;
          let remarkList = this.currentClassImages.remark_img_list.map(
            a => a.img_uuid
          );
          let res1 = await apiGetImgByUuidList(deletedList);
          let res2 = await apiGetImgByUuidList(remarkList);
          let arr = this.currentClassImages.remark_img_list.map((a, idx) => {
            let tar = this.$_.find(this.modelList, c => c.class_id === a.class_id);
            return {
              class_id: a.class_id,
              dish_url: tar.dish_image_url,
              img_url: res2.img_url_list[idx].img_url,
              img_uuid: a.img_uuid
            };
          });
          console.log(arr);
          this.$set(this, 'currentClassDeleted', res1.img_url_list);
          this.$set(this, 'currentClassRemark', arr);
        }
        this.removeLoading();
      } catch (e) {
        this.removeLoading();
        this.$message.error('获取任务的详细信息失败' + e.message);
        console.log(e);
      }
    },
    back () {
      this.$router.push({
        name: 'taskAdmin'
      });
    },
    async getModelList () {
      try {
        let res = await apiQueryCanteenClassList({
          canteenId: this.canteen.canteen_id,
          apiKey: this.apiKey
        });
        console.log(res.dish_info_list);
        this.modelList2 = res.dish_info_list;
      } catch (e) {
        console.log(e);
      }
    },
    pageChange (page, isLastPage) {
      this.isLastPage = isLastPage;
    },
    unDelete (dish) {
      this.unMark({dish_img_uuid: dish.dish_img_uuid});
    },
    showCheckFailReasonDialog () {
      this.checkFailReasonShow = true;
    },
    cancelDialog () {
      this.checkFailReason = '';
      this.checkFailReasonShow = false;
    },
    async nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        // let remarkList = this.currentClassImages.remark_img_list;
        // let res = await apiGetImgByUuidList(deletedList);
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    submitMarkedData () {
      this.$alert('标注还未完成, 请继续标注', '', {
        confirmButtonText: '确定'
      });
    },
    checkComplete () {
      this.$alert('即将跳转到标注页面', '提示', {
        confirmButtonText: '确定',
        callback: () => {
          this.$router.push({
            path: '/dataMark/markProcess1',
            params: {
              selfCheck: true
            }
          });
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      'markedImageList',
      'listQuery',
      'userinfo',
      'checkTextObjList',
      'taskUuid'
    ]),
    checkMode () {
      return this.$route.params.checkMode;
    },
    choose_class_idx () {
      if (this.$route.params.hasOwnProperty('class_id')) {
        const class_id = this.$route.params.class_id;
        let idx = this.$_.findIndex(this.modelList, a => a.class_id === class_id);
        return idx === -1 ? 0 : idx;
      } else {
        return 0;
      }
    },
    currentClassImages () {
      let obj = this.checkedHistory[this.currentDishModel.class_id];
      return this.checkedHistory[this.currentDishModel.class_id];
    },
    currentTask () {
      return this.label_task_uuid_list[this.labelTaskIndex];
    },
    label_task_uuid_list () {
      const label_task_uuid = this.$route.params.taskInfo.label_task_uuid;
      if (this.$_.isArray(label_task_uuid)) {
        return label_task_uuid;
      } else {
        return [label_task_uuid];
      }
    },
    taskInfo () {
      return this.$route.params.taskInfo;
    },
    username () {
      return this.userinfo().username;
    },
    filterWrapperShow () {
      return !this.$route.params.canteen;
    },
    canteen () {
      let {canteen_id, canteen_name} = this.taskInfo;
      return {canteen_id, canteen_name};
    },
    dateRange () {
      let day_ts = this.taskInfo.day_ts;
      return {
        start_ts: day_ts,
        end_ts: day_ts + 24 * 3600
      };
    },
    allImageList () {
      let arr = Object.values(this.detectedData);
      arr = arr.map(a => a.marked_img_info);
      arr = this.$_.flatten(arr).map(a => a.dish_img_uuid);
      return arr;
    },
    modelList1 () {
      return this.$store.getters.modelList;
    },
    modelList () {
      let res = this.classDishList.map(a => {
        let target = this.$_.find(this.modelList2, b => {
          return a.class_id === b.class_id;
        });
        if (target) {
          target.dish_name = target.dish_name
            ? target.dish_name
            : target.dish_native_name
              ? target.dish_native_name + '(碗碟库)'
              : '暂无名称';
          return target;
        } else {
          return a;
        }
      });
      return res;
      // return this.modelList2;
    },
    markedListFlatten () {
      let markedListClassIdList = this.$_.keys(this.detectedData);
      let markedListArray = this.$_.values(this.detectedData);
      let arr = markedListArray.map(a => {
        return a.marked_img_info;
      });
      arr = this.$_.flatten(arr);
      // arr = this.$_.differenceBy(arr, this.deletedImages, 'dish_img_uuid');
      return arr.map(a => a.dish_img_uuid);
    },
    selfCheck () {
      if (this.$route.params.selfCheck) {
        return this.$route.params.selfCheck;
      } else {
        return false;
      }
    },
    currentClassImagesLeft () {
     if (this.currentClassImages.hasOwnProperty('marked_img_info')) {
       let list = this.currentClassImages.marked_img_info.filter(
         a => a.class_id !== '-1' && a.class_id !== -1
       );
       let deleted = this.currentClassImages.delete_img_list;
       if (this.$_.isEmpty(deleted)) {
         return list;
       } else {
         return this.$_.differenceWith(list, deleted, (left, right) => {
           return left.dish_img_uuid === right;
         });
       }
     } else {
       return [];
     }
    },

    apiKey () {
      return this.userinfo().api_key;
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    dishModelCount () {
      return this.modelList.length || 0;
    },
    currentDishModel () {
      return this.modelList[this.currentIndex] || '';
    },
    tsToDate () {
      return moment(this.taskInfo.day_ts * 1000).format('YYYY年MM月DD日');
    }
  },
  watch: {
    async currentIndex () {
      // currentClassDeleted() {
      //    return this.currentClassImages.delete_img_list;
      //  },
      //  currentClassRemark() {
      //    return this.currentClassImages.remark_img_list;
      //  },
      this.$set(this, 'currentClassDeleted', []);
      this.$set(this, 'currentClassRemark', []);
      let deletedList = this.currentClassImages.delete_img_list;
      let remarkList = this.currentClassImages.remark_img_list.map(
        a => a.img_uuid
      );
      let res = await apiGetImgByUuidList(deletedList);
      let res2 = await apiGetImgByUuidList(remarkList);
      let arr = this.currentClassImages.remark_img_list.map((a, idx) => {
        let tar = this.$_.find(this.modelList, c => c.class_id === a.class_id);
        return {
          class_id: a.class_id,
          dish_url: tar.dish_image_url,
          img_url: res2.img_url_list[idx].img_url,
          img_uuid: a.img_uuid
        };
      });
      console.log(arr);
      this.$set(this, 'currentClassDeleted', res.img_url_list);
      this.$set(this, 'currentClassRemark', arr);
    },
    listQuery: {
      handler () {
        this.getBackImages();
      },
      deep: true
    },
    currentTask () {
      // return undefined;
      this.getTaskInfo();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .main-title {
    top: -35px;
  }
	.tip-wrapper {
		display: inline-block;
		width: auto;
		padding: 20px;
		border: 2px solid red;
		border-radius: 20px;
	}
	.tip {
		display: inline-block;
		vertical-align: top;
		height: 40px;
		line-height: 40px;
	}
	.unMarked-card {
		height: 100%;
	}
	.header-title {
		display: inline-block;
	}
	.box-card {
		.btn-wrapper-1 {
			display: inline-block;
			margin-top: -10px;
			float: right;
		}
	}

	.btn-wrapper {
		padding-top: 50px;
		width: 80%;

		.btn-wrapper-1 {
			display: inline-block;
			margin-top: -10px;
			float: right;
		}
	}

	.class-dish-wrapper {
		display: inline-block;
		width: 150px;
		height: 150px;
	}

	.image-wrapper {
		width: 100%;

		.image-item {
			width: auto;
			height: auto;
			max-width: 100%;
			max-height: 100%;
		}

		.image-item-wrapper {
			display: inline-block;
			width: 50px;
			height: 50px;

			.big-img {
				width: 50px;
				height: 50px;
			}
		}
	}

	.image-wrapper-deleted {
		border: 1px solid #ccc;
	}

	.process-title {
		.strong-text {
			color: #ff0000;
		}
	}
}

.big-img-wrapper {
	position: relative;

	.image-wrapper {
		vertical-align: top;
		display: inline-block;
		width: 300px;
		height: 300px;

		.image-item {
			width: auto;
			height: auto;
			max-width: 100%;
			max-height: 100%;
		}
	}

	.class-dish-wrapper {
		width: 100px;
		height: 100px;
		display: inline-block;
	}

	.btn {
		position: absolute;
		left: 0;
		top: 0;
	}
}
</style>
